const COLORS = {
  PRIMARY: {
    main: '#ff6f00', // Orange color for primary
    light: '#ff9e3d', // Light orange color
    dark: '#c43e00', // Darker orange color
    contrastText: '#ffffff', // White text on primary
  },

  SECONDARY: {
    main: '#424242', // Dark grey color for secondary
    light: '#6d6d6d', // Lighter grey
    dark: '#1b1b1b', // Darker grey
    contrastText: '#ffffff', // White text on secondary
  },

  ERROR: {
    main: '#d32f2f', // Red color for error
    light: '#ff6659', // Lighter red
    dark: '#9a0007', // Darker red
    contrastText: '#ffffff', // White text on error
  },

  WARNING: {
    main: '#ff9800', // Orange-yellow color for warning
    light: '#ffb74d', // Lighter orange-yellow
    dark: '#f57c00', // Darker orange-yellow
    contrastText: '#ffffff', // White text on warning
  },

  INFO: {
    main: '#0288d1', // Blue color for info
    light: '#33b5e5', // Lighter blue
    dark: '#01579b', // Darker blue
    contrastText: '#ffffff', // White text on info
  },

  SUCCESS: {
    main: '#388e3c', // Green color for success
    light: '#66bb6a', // Lighter green
    dark: '#00600f', // Darker green
    contrastText: '#ffffff', // White text on success
  },
};

export default COLORS;
